import type { SettingsSource } from '../models/settings-hub.model';

import { field } from './settings-builders';
export const CUSTOMER_DISPLAY_SUBCATEGORY: SettingsSource = {
    id: 'customer-display',
    cards: [
        {
            id: 'display-configuration',
            settings: [
                field.toggle('customer_display.enable_two_rows_display', 'SETTINGS.CUSTOMER_DISPLAY.ENABLE_TWO_ROWS_DISPLAY'),
                field.number('customer_display.display_row_size', 'SETTINGS.CUSTOMER_DISPLAY.DISPLAY_ROW_SIZE', { min: 0, max: 60 }),
                field.text('customer_display.serial_port_address', 'SETTINGS.CUSTOMER_DISPLAY.SERIAL_PORT_ADDRESS'),
                field.toggle('customer_display.enable_network_display', 'SETTINGS.CUSTOMER_DISPLAY.ENABLE_NETWORK_DISPLAY'),
                field.text('customer_display.network_display_ip_address', 'SETTINGS.CUSTOMER_DISPLAY.NETWORK_DISPLAY_IP_ADDRESS'),
                field.toggle('customer_display.enable_color_display', 'SETTINGS.CUSTOMER_DISPLAY.ENABLE_COLOR_DISPLAY')
            ]
        },
        {
            id: 'display-content',
            settings: [
                field.text('customer_display.greeting_message', 'SETTINGS.CUSTOMER_DISPLAY.GREETING_MESSAGE'),
                field.text('customer_display.thankyou_message', 'SETTINGS.CUSTOMER_DISPLAY.THANKYOU_MESSAGE'),
                field.text('customer_display.logo_url', 'SETTINGS.CUSTOMER_DISPLAY.LOGO_URL'),
                field.text('customer_display.standby_url', 'SETTINGS.CUSTOMER_DISPLAY.STANDBY_URL'),
                field.number('customer_display.thankyou_message_timeout', 'SETTINGS.CUSTOMER_DISPLAY.THANKYOU_MESSAGE_TIMEOUT', { min: 0, max: 60, defaultValue: 10 }),
                field.toggle('customer_display.ask_customer_survey', 'SETTINGS.CUSTOMER_DISPLAY.ASK_CUSTOMER_SURVEY')
            ]
        }
    ]
};
